"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var FullScreen = function FullScreen(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 68 68'
  }, props), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M6.161,4H19.5c1.104,0,2-0.896,2-2s-0.896-2-2-2h-17C1.396,0,0,1.276,0,2.381v17c0,1.104,0.896,2,2,2s2-0.896,2-2V8.376\r l16.042,15.791c0.391,0.391,1.027,0.586,1.539,0.586s1.086-0.195,1.477-0.586c0.781-0.781,0.812-2.237,0.031-3.019L6.161,4z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M66.5,0h-17c-1.104,0-2,0.896-2,2s0.896,2,2,2h12.605L45.147,21.148c-0.781,0.781-0.781,2.142,0,2.923\r c0.39,0.391,0.902,0.633,1.414,0.633s0.774-0.171,1.164-0.562l16.274-16.5V19.38c0,1.104,0.896,2,2,2s2-0.896,2-2v-17\r C68,1.276,67.604,0,66.5,0z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M20.042,44.462L4,60.254V49.381c0-1.104-0.896-2-2-2s-2,0.896-2,2v17C0,67.485,1.396,68,2.5,68h17c1.104,0,2-0.896,2-2\r s-0.896-2-2-2H6.029L23.12,47.1c0.781-0.781,0.656-1.951-0.125-2.732C22.215,43.586,20.822,43.681,20.042,44.462z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M66,47.381c-1.104,0-2,0.896-2,2v11.606L47.726,44.462c-0.78-0.781-1.923-0.781-2.703,0\r c-0.781,0.781-0.719,1.856,0.062,2.638L62.237,64H49.5c-1.104,0-2,0.896-2,2s0.896,2,2,2h17c1.104,0,1.5-0.515,1.5-1.619v-17\r C68,48.276,67.104,47.381,66,47.381z'
  }));
};
/* eslint-enable */
var _default = FullScreen;
exports["default"] = _default;